import { z } from 'zod';
import { parseOptionalNonNegativeInt } from '../../parse-optional-non-negative-int.js';
export const optionalNonNegativeIntString = (label) => z.string().superRefine((value, context) => {
    const result = parseOptionalNonNegativeInt(value, label);
    if (typeof result === 'string') {
        context.addIssue({
            code: 'custom',
            message: result,
            path: [],
        });
    }
});
//# sourceMappingURL=optional-non-negative-int-string.js.map